module.exports = __webpack_public_path__ + "img/pwa-role-bind.1654b46a.png";